
import { defineComponent, computed, ref } from 'vue'
import { AuthenticationLog } from '@/modules/authentication-logs/types'
import { useRoute, useRouter } from 'vue-router'
import { useAuthenticationLogsModule } from '@/modules/authentication-logs'
import { AuthenticationLogsRouteNames } from '@/router/routes-names'
import { useAPIPagination } from '@/views/_shared/search-list/pagination'
import { SimpleSearchFilter } from '@/views/_shared/search-list/types'
import { FormModelCacheTag, restoreFormModelTo } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'view-authentication-logs',
    props: {
        restoreFilters: {
            type: [Boolean, String]
        }
    },
    async setup (props) {
        const { getAuthenticationLogs, authenticationLogs, authenticationLogsFilter, authenticationLogsCount } = useAuthenticationLogsModule()
        const router = useRouter()
        const route = useRoute()

        const authenticationLogsColumns = ([
            { name: 'id', label: 'Id', field: 'id', sortable: true, align: 'left' },
            { name: 'createdAt', label: 'Entrance trial time', field: 'createdAt', sortable: true, align: 'left' },
            { name: 'ip', label: 'IP', field: 'ip', sortable: true, align: 'left' },
            { name: 'username', label: 'Entered login', field: 'username', sortable: true, align: 'left' },
            { name: 'agent', label: 'Browser', field: 'agent', sortable: true, align: 'left' },
            { name: 'isLoginCorrect', label: 'Was login name correct', field: 'isLoginCorrect', sortable: true, align: 'left' },
            { name: 'isSuccess', label: 'Was user logged in with success', field: 'isSuccess', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const visibleColumns = computed(() => {
            const columnNames = authenticationLogsColumns.map(el => el.name)
            const index = columnNames.indexOf('id')
            columnNames.splice(index, 1)
            return columnNames
        })

        const restoredFilter = { value: '' } as SimpleSearchFilter
        if (props.restoreFilters) {
            restoreFormModelTo(restoredFilter, FormModelCacheTag.AUTH_LOGS_LIST_FILTERS)
        }

        const filter = ref<string>(restoredFilter.value ?? '')
        const currentPage = computed(() => route.query.page === null ? '1' : route.query.page)

        const { loading, pagination, onRequest } = useAPIPagination(authenticationLogsFilter, getAuthenticationLogs, authenticationLogsCount, currentPage, true, FormModelCacheTag.AUTH_LOGS_LIST_FILTERS)

        function onShowAuthenticationLog (evt: PointerEvent | null, props: AuthenticationLog) {
            router.push({ name: AuthenticationLogsRouteNames.SHOW, params: { id: props.id }, query: { page: route.query.page } })
        }

        await onRequest({
            filter: filter.value || '',
            pagination: pagination.value
        })

        return {
            onRequest,
            authenticationLogs,
            authenticationLogsColumns,
            onShowAuthenticationLog,
            visibleColumns,
            pagination,
            filter,
            loading
        }
    }
})
